/* eslint-disable no-unused-vars */
import React, { useRef, createContext, useEffect } from 'react';
import { Box, Button, useTheme } from '@material-ui/core';
// import LoadingButton from '@material-ui/lab/LoadingButton';
import { useDispatch, useSelector } from 'dva';
import { history, useIntl } from 'umi';
import ReplyIcon from '@material-ui/icons/Reply';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import StepsML from './components/StepsML';
import StepOneML from './components/StepOneML';
import StepTwoML from './components/StepTwoML';
import StepThreeML from './components/StepThreeML';
import StepFourML from './components/StepFourML';
import SettingStyled from './settingStyles';
export const Context = createContext({});

let bType = null;

const dateRegExp = /\d{2}:\d{2}:\d{2}$/;

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const id = history.location?.query?.id;
  const queryType = history.location?.query?.opt;
  const cType = history.location?.query?.type;
  const sourceOid = history.location?.query?.sourceOid;
  const theme = useTheme();
  const dispatch = useDispatch();
  const childRef = useRef();
  const childRefTwo = useRef();
  const childRefThree = useRef();
  const childRefFour = useRef();
  const saveRef = useRef();
  let {
    step,
    storeName,
    storeCode,
    storeStatus,
    storeType,
    storesPageNum,
    storesPageSize,
    productsName,
    productsPageNum,
    productsPageSize,
    productsNameSeries,
    productsPageNumSeries,
    productsPageSizeSeries,
    productsNameStyles,
    productsPageNumStyles,
    productsPageSizeStyles,
    productsNameGoods,
    productsPageNumGoods,
    productsPageSizeGoods,
    productsNameSeason,
    productsPageNumSeason,
    productsPageSizeSeason,
    productsNameSubclass,
    productsPageNumSubclass,
    productsPageSizeSubclass,
    productsNameDesign,
    productsPageNumDesign,
    productsPageSizeDesign,
    productsNameCategory,
    productsPageNumCategory,
    productsPageSizeCategory,
  } = useSelector((state) => state.couponsSetting);

  const onSubmitSuccess = (formData) => {
    if (step === 0) {
      for (let i in formData) {
        if (i === 'memberLimit' || i === 'isLimitMaxCoupons') {
          formData[i] = formData[i] === 'true';
        } else if (
          [
            'isOver',
            'isMemberDiscount',
            'isActivityOver',
            'isNonPositive',
          ].includes(i)
        ) {
          formData[i] = !formData[i];
        } else if (i === 'date') {
          // data.beginTime = `${data[i].startDate} 00:00:00`;
          formData.beginTime = dateRegExp.test(formData[i].startDate)
            ? formData[i].startDate
            : `${formData[i].startDate} 00:00:00`;
          // data.endTime = `${data[i].endDate} 23:59:59`;
          formData.endTime = dateRegExp.test(formData[i].endDate)
            ? formData[i].endDate
            : `${formData[i].endDate} 23:59:59`;
        }
      }
    } else if (step === 1) {
      const types = [];
      const onlineData = {
        app: 2,
        web: 1,
        h5: 3,
        wechat: 4,
        offline: 6,
        etoshop: 5,
        privateProgram: 7,
      };
      for (let i in formData) {
        if (
          [
            'app',
            'etoshop',
            'h5',
            'offline',
            'web',
            'wechat',
            'privateProgram',
          ].includes(i) &&
          formData[i]
        ) {
          types.push(onlineData[i]);
          delete formData[i];
        }
        if (i === 'discountPercent') {
          formData[i] = Number(formData[i]);
        }
        if (i === 'stores') {
          if (formData[i]) {
            formData[i] = JSON.parse(formData[i]);
          } else {
            formData[i] = [];
          }
        }
        if (i === 'invertStores') {
          if (formData[i]) {
            formData[i] = JSON.parse(formData[i]);
          } else {
            formData[i] = [];
          }
        }
      }
      formData.usedType = types;
    } else if (step === 2) {
      for (let i in formData) {
        if (
          [
            'goodsProduct',
            'goodsSeries',
            'goodsSeason',
            'goodsStyles',
            'goodsGoods',
            'goodsSubclass',
            'goodsDesign',
            'goodsCategory',
            'goodsProductNo',
            'goodsSeriesNo',
            'goodsSeasonNo',
            'goodsSubclassNo',
            'goodsDesignNo',
            'goodsStylesNo',
            'goodsGoodsNo',
            'goodsCategoryNo',
          ].includes(i)
        ) {
          if (formData[i]) {
            formData[i] = JSON.parse(formData[i]);
          } else {
            formData[i] = [];
          }
        }
      }
    } else {
      for (let i in formData) {
        if (i === 'channelType') {
          formData[i] = formData[i] ? 2 : 1;
        }
      }
      formData.sendStartDate = formData.isSend
        ? formData?.isSendDate?.startDate
        : null;
      formData.sendEndDate = formData.isSend
        ? formData?.isSendDate?.endDate
        : null;
      formData.expireStartDate = formData.isExpire
        ? formData?.expireCouponDate?.startDate
        : null;
      formData.expireEndDate = formData.isExpire
        ? formData?.expireCouponDate?.endDate
        : null;
    }
    if (bType === 1) {
      dispatch({
        type: 'couponsSetting/resetForm',
        payload: {
          value: {
            stepOneData: formData,
            key: 'stepOneData',
            step: --step,
          },
        },
      });
      return;
    }
    dispatch({
      type: 'couponsSetting/resetForm',
      payload: {
        value: {
          stepOneData: formData,
          key: 'stepOneData',
          step: step < 4 ? ++step : 4,
        },
      },
      callback: (obj) => {
        // step === 4 && setSaveLoading(true);
        if (step === 4) {
          const varr = [
            'channelType',
            'discountAmount',
            'discountPercent',
            'goodsNum',
            'isAllGoods',
            'isAllStore',
            'maxCouponsPerUser',
            'quantity',
            'templateId',
            'transactionMinimum',
            'validBegin',
            'validDays',
          ];
          obj.isSend = obj.isSend ? 1 : 0;
          obj.isExpire = obj.isExpire ? 1 : 0;
          for (let key in obj) {
            if (varr.includes(key) && obj[key]) {
              obj[key] = Number(obj[key]);
            }
          }
          for (let key in obj) {
            if (key === 'isAllStore' && obj.isAllStore === 1) {
              obj.useStory = false;
              obj.noUseStory = false;
            }
            if (key === 'isAllGoods' && obj.isAllGoods === 1) {
              obj.useProduct = false;
              obj.noUseProduct = false;
            }
            if (key === 'date') {
              // obj.beginTime = `${obj[key].startDate}`;
              obj.beginTime = dateRegExp.test(obj[key].startDate)
                ? obj[key].startDate
                : `${obj[key].startDate} 00:00:00`;
              // obj.endTime = `${obj[key].endDate}`;
              obj.endTime = dateRegExp.test(obj[key].endDate)
                ? obj[key].endDate
                : `${obj[key].endDate} 23:59:59`;
            }
            if (key === 'stores') {
              obj[key] =
                obj.useStory && Number(obj.isAllStore) === 0 ? obj[key] : [];
            }
            if (key === 'invertStores') {
              obj[key] =
                obj.noUseStory && Number(obj.isAllStore) === 0 ? obj[key] : [];
            }
            if (
              [
                'goodsProduct',
                'goodsSeries',
                'goodsSeason',
                'goodsStyles',
                'goodsGoods',
                'goodsSubclass',
                'goodsDesign',
                'goodsCategory',
              ].includes(key)
            ) {
              obj[key] =
                obj.useProduct && Number(obj.isAllGoods) === 0 ? obj[key] : [];
            }
            if (
              [
                'goodsProductNo',
                'goodsSeriesNo',
                'goodsSeasonNo',
                'goodsStylesNo',
                'goodsGoodsNo',
                'goodsSubclassNo',
                'goodsDesignNo',
                'goodsCategoryNo',
              ].includes(key)
            ) {
              obj[key] =
                obj.noUseProduct && Number(obj.isAllGoods) === 0
                  ? obj[key]
                  : [];
            }
            if (key === 'thirdFilePath') {
              obj[key] = obj[key] ? JSON.parse(obj[key])[0].url : '';
            }
          }
          let goods = [];
          goods = [
            ...obj.goodsProduct,
            ...obj.goodsSeries,
            ...obj.goodsSeason,
            ...obj.goodsStyles,
            ...obj.goodsGoods,
            ...obj.goodsSubclass,
            ...obj.goodsDesign,
            ...obj.goodsCategory,
          ];
          obj.goods = goods;
          let invertGoods = [];
          invertGoods = [
            ...obj.goodsProductNo,
            ...obj.goodsSeriesNo,
            ...obj.goodsSeasonNo,
            ...obj.goodsStylesNo,
            ...obj.goodsGoodsNo,
            ...obj.goodsSubclassNo,
            ...obj.goodsDesignNo,
            ...obj.goodsCategoryNo,
          ];
          obj.invertGoods = invertGoods;
          //解构删除
          const {
            couponUsingThreshold,
            couponGetCheckbox,
            date,
            goodsProduct,
            goodsSeries,
            goodsSeason,
            goodsStyles,
            goodsGoods,
            goodsSubclass,
            goodsDesign,
            goodsCategory,
            noUseStory,
            useStory,
            goodsProductNo,
            goodsSeriesNo,
            goodsSeasonNo,
            goodsStylesNo,
            goodsGoodsNo,
            goodsSubclassNo,
            goodsDesignNo,
            goodsCategoryNo,
            noUseProduct,
            useProduct,
            expireCouponDate,
            isSendDate,
            ...params
          } = obj;
          // const
          dispatch({
            type: id
              ? 'couponsSetting/updateCoupon'
              : 'couponsSetting/addCoupon',
            payload: {
              value: {
                stepOneData: params,
              },
            },
            callback: (response) => {
              if (response === '200') {
                window.NE_DAWN.trigger(saveRef.current, {
                  event: '_ec', // 事件名
                  params, // 事件公参
                });
                history.go(-1);
              }
            },
          });
        }
      },
    });
  };
  const settingHandleNextClick = (type) => {
    bType = type;
    step === 0 && childRef.current.clickInput();
    step === 1 && childRefTwo.current.clickInput();
    step === 2 && childRefThree.current.clickInput();
    step === 3 && childRefFour.current.clickInput();
  };

  // const settingHandleBackClick = () => {
  //   dispatch({
  //     type: 'couponsSetting/nextStep',
  //     payload: {
  //       value: --step,
  //     },
  //   });
  // };

  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getCompany',
      payload: {},
    });
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch({
  //     type: 'couponsSetting/getQueryTemplateList',
  //     payload: {},
  //   });
  // }, [dispatch]);
  //编辑初始化接口
  useEffect(() => {
    id &&
      dispatch({
        type: 'couponsSetting/couponInitData',
        payload: {
          value: {
            id,
          },
        },
      });
  }, []);

  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getStores',
      payload: {
        value: {
          name: storeName,
          code: storeCode,
          status: storeStatus,
          type: storeType,
          pageNum: storesPageNum,
          pageSize: storesPageSize,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    storeName,
    storesPageNum,
    storesPageSize,
    storeCode,
    storeStatus,
    storeType,
  ]);
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProductsSeries',
      payload: {
        value: {
          addType: 'SERIES',
          addTypeName: productsNameSeries,
          pageNum: productsPageNumSeries,
          pageSize: productsPageSizeSeries,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    productsNameSeries,
    productsPageNumSeries,
    productsPageSizeSeries,
  ]);
  // 获取款号接口
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProductsStyle',
      payload: {
        value: {
          addType: 'SPU',
          addTypeName: productsNameStyles,
          pageNum: productsPageNumStyles,
          pageSize: productsPageSizeStyles,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    productsNameStyles,
    productsPageNumStyles,
    productsPageSizeStyles,
  ]);
  // 获取货号接口
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProductsGoods',
      payload: {
        value: {
          addType: 'MATERIAL_CODE',
          addTypeName: productsNameGoods,
          pageNum: productsPageNumGoods,
          pageSize: productsPageSizeGoods,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    productsNameGoods,
    productsPageNumGoods,
    productsPageSizeGoods,
  ]);
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProductsSeason',
      payload: {
        value: {
          addType: 'SEASON',
          addTypeName: productsNameSeason,
          pageNum: productsPageNumSeason,
          pageSize: productsPageSizeSeason,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    productsNameSeason,
    productsPageNumSeason,
    productsPageSizeSeason,
  ]);
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProductsSubclass',
      payload: {
        value: {
          addType: 'SUBCLASS',
          addTypeName: productsNameSubclass,
          pageNum: productsPageNumSubclass,
          pageSize: productsPageSizeSubclass,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    productsNameSubclass,
    productsPageNumSubclass,
    productsPageSizeSubclass,
  ]);
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProductsDesign',
      payload: {
        value: {
          addType: 'STYLE',
          addTypeName: productsNameDesign,
          pageNum: productsPageNumDesign,
          pageSize: productsPageSizeDesign,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    productsNameDesign,
    productsPageNumDesign,
    productsPageSizeDesign,
  ]);
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProductsCategory',
      payload: {
        value: {
          addType: 'GENERAL_CATEGORY',
          addTypeName: productsNameCategory,
          pageNum: productsPageNumCategory,
          pageSize: productsPageSizeCategory,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    productsNameCategory,
    productsPageNumCategory,
    productsPageSizeCategory,
  ]);
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getProducts',
      payload: {
        value: {
          name: productsName,
          pageNum: productsPageNum,
          pageSize: productsPageSize,
          sort: null,
        },
      },
    });
  }, [dispatch, productsName, productsPageNum, productsPageSize]);
  const handleClickSearchStores = (data) => {
    dispatch({
      type: 'couponsSetting/searchStores',
      payload: {
        value: data,
      },
    });
  };
  const handleClickSearchProducts = (data) => {
    dispatch({
      type: 'couponsSetting/searchProducts',
      payload: {
        value: {
          productsName: data,
        },
      },
    });
  };
  const handleClickSearchSeries = (data) => {
    dispatch({
      type: 'couponsSetting/searchProductsSeries',
      payload: {
        value: {
          productsNameSeries: data,
        },
      },
    });
  };

  const handleClickSearchStyles = (data) => {
    dispatch({
      type: 'couponsSetting/searchProductsStyles',
      payload: {
        value: {
          productsNameStyles: data,
        },
      },
    });
  };

  const handleClickSearchGoods = (data) => {
    dispatch({
      type: 'couponsSetting/searchProductsGoods',
      payload: {
        value: {
          productsNameGoods: data,
        },
      },
    });
  };

  const handleClickSearchSeason = (data) => {
    dispatch({
      type: 'couponsSetting/searchProductsSeason',
      payload: {
        value: {
          productsNameSeason: data,
        },
      },
    });
  };
  const handleClickSearchSubclass = (data) => {
    dispatch({
      type: 'couponsSetting/searchProductsSubclass',
      payload: {
        value: {
          productsNameSubclass: data,
        },
      },
    });
  };
  const handleClickSearchDesign = (data) => {
    dispatch({
      type: 'couponsSetting/searchProductsDesign',
      payload: {
        value: {
          productsNameDesign: data,
        },
      },
    });
  };
  const handleClickSearchCategory = (data) => {
    dispatch({
      type: 'couponsSetting/searchProductsCategory',
      payload: {
        value: {
          productsNameCategory: data,
        },
      },
    });
  };
  //reset
  const handleResetForm = (key, value) => {
    dispatch({
      type: 'couponsSetting/initEachForm',
      payload: {
        value: {
          [key]: value,
        },
      },
    });
  };

  return (
    <SettingStyled theme={theme}>
      <Box
        height="100%"
        data-log={JSON.stringify({
          oid: 'page_coupon_center_coupon_management_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
            source: sourceOid,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <Box
          borderRadius="4px"
          bgcolor="background.paper"
          pt={5.25}
          pb={4}
          mt={1.5}
        >
          <StepsML formatMessage={formatMessage} />
          <Box mt={9.5} mb={6}>
            {step === 0 ? (
              <Context.Provider
                value={{
                  ref: childRef,
                }}
              >
                <StepOneML
                  onSubmitSuccess={onSubmitSuccess}
                  queryType={queryType}
                  cType={cType}
                  handleResetForm={handleResetForm}
                  formatMessage={formatMessage}
                />
              </Context.Provider>
            ) : step === 1 ? (
              <Context.Provider
                value={{
                  ref: childRefTwo,
                }}
              >
                <StepTwoML
                  onSubmitSuccess={onSubmitSuccess}
                  handleClickSearchStores={handleClickSearchStores}
                  queryType={queryType}
                  handleResetForm={handleResetForm}
                  formatMessage={formatMessage}
                />
              </Context.Provider>
            ) : step === 2 ? (
              <Context.Provider
                value={{
                  ref: childRefThree,
                }}
              >
                <StepThreeML
                  onSubmitSuccess={onSubmitSuccess}
                  handleClickSearchProducts={handleClickSearchProducts}
                  handleClickSearchProductsSeries={handleClickSearchSeries}
                  handleClickSearchProductsStyles={handleClickSearchStyles}
                  handleClickSearchProductsGoods={handleClickSearchGoods}
                  handleClickSearchProductsSeason={handleClickSearchSeason}
                  handleClickSearchProductsSubclass={handleClickSearchSubclass}
                  handleClickSearchProductsDesign={handleClickSearchDesign}
                  handleClickSearchProductsCategory={handleClickSearchCategory}
                  queryType={queryType}
                  formatMessage={formatMessage}
                />
              </Context.Provider>
            ) : (
              <Context.Provider
                value={{
                  ref: childRefFour,
                }}
              >
                <StepFourML
                  onSubmitSuccess={onSubmitSuccess}
                  queryType={queryType}
                  formatMessage={formatMessage}
                />
              </Context.Provider>
            )}
          </Box>
          <Box display="flex" gap="0 4px" pl={7} className="coupon-button-wrap">
            {step !== 0 && (
              <Button
                color="secondary"
                variant="contained"
                className="coupons-setting-button"
                onClick={() => settingHandleNextClick(1)}
                title="Submit"
                startIcon={<ReplyIcon sx={{ width: '16px', height: '16px' }} />}
              >
                {/*上一步*/}
                {formatMessage({ id: 'comm.action.btn.14' })}
              </Button>
            )}
            {step < 3 ? (
              <Button
                variant="contained"
                className="coupons-setting-button"
                onClick={() => settingHandleNextClick(2)}
                title="Submit"
                startIcon={
                  <ReplyIcon
                    sx={{ width: '16px', height: '16px' }}
                    className="next-button-icon"
                  />
                }
              >
                {formatMessage({ id: 'comm.action.btn.13' })}
              </Button>
            ) : (
              queryType !== 'detail' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_coupon_center_coupon_management_edit_finish',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                      source: sourceOid,
                    },
                  })}
                  ref={saveRef}
                  variant="contained"
                  className="coupons-setting-button"
                  onClick={() => settingHandleNextClick(2)}
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  {formatMessage({ id: 'comm.action.btn.17' })}
                </Button>
              )
            )}
            <Button
              variant="contained"
              className="coupons-setting-button"
              color="secondary"
              onClick={() => history.goBack()}
              startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.16' })}
            </Button>
            {/* <LoadingButton
              loading={saveLoading}
              loadingPosition="start"
              startIcon={saveLoading&&<SaveIcon />}
              variant="contained"
              className="loading-button"
              onClick={settingHandleNextClick}
            >
              完成
            </LoadingButton> */}
          </Box>
        </Box>
      </Box>
    </SettingStyled>
  );
};
